/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.15.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetHealth200Response,
  GetHealth500Response,
  SetDatabaseChange200Response,
  SetDatabaseChange401Response,
  SetDatabaseChange500Response,
  SetDatabaseChangeRequest,
} from '../models/index';
import {
    GetHealth200ResponseFromJSON,
    GetHealth200ResponseToJSON,
    GetHealth500ResponseFromJSON,
    GetHealth500ResponseToJSON,
    SetDatabaseChange200ResponseFromJSON,
    SetDatabaseChange200ResponseToJSON,
    SetDatabaseChange401ResponseFromJSON,
    SetDatabaseChange401ResponseToJSON,
    SetDatabaseChange500ResponseFromJSON,
    SetDatabaseChange500ResponseToJSON,
    SetDatabaseChangeRequestFromJSON,
    SetDatabaseChangeRequestToJSON,
} from '../models/index';

export interface SetDatabaseChangeOperationRequest {
    setDatabaseChangeRequest?: SetDatabaseChangeRequest;
}

/**
 * 
 */
export class OtherApi extends runtime.BaseAPI {

    /**
     * get api health status
     */
    async getHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHealth200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/services/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHealth200ResponseFromJSON(jsonValue));
    }

    /**
     * get api health status
     */
    async getHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHealth200Response> {
        const response = await this.getHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Notify backend on data change, called via hasura event webhook
     */
    async setDatabaseChangeRaw(requestParameters: SetDatabaseChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/services/ioe/data-change`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetDatabaseChangeRequestToJSON(requestParameters['setDatabaseChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Notify backend on data change, called via hasura event webhook
     */
    async setDatabaseChange(setDatabaseChangeRequest?: SetDatabaseChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.setDatabaseChangeRaw({ setDatabaseChangeRequest: setDatabaseChangeRequest }, initOverrides);
        return await response.value();
    }

}
